import {
  ChangeDetectorRef,
  Component,
  DoCheck,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {UserService} from "../service/user.service";
import {UserRole} from "../enums/UserRole";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {filter, of, Subscription, take} from "rxjs";
import {ViewStateService} from "../service/view-state.service";
import {DeleteProfileCardComponent} from "../profile-card/delete-profile-card/delete-profile-card.component";
import {MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {UserCardService} from "../service/user-card.service";
import {HeaderDataService} from "../service/header-data-service";
import {CardsHistoryService} from "../service/cards-history.service";
import {FavoriteCardsService} from "../service/favorite-cards.service";
import {
  DELETE_ALL_FAVORITES_CARD_TITLE,
  DELETE_ALL_VIEWED_CARD_TITLE,
  DELETE_DESCRIPTION
} from "../constants/deleteProfileCards.constant";
import {UserEditProfileComponent} from "../user-edit-profile/user-edit-profile.component";
import {HttpErrorResponse} from "@angular/common/http";
import {CREATE_CARD_LIMIT_ERROR_ALERT, DEFAULT_USER_ICON, SCAN_ME_LOGO} from "../constants/global.constants";
import {HeaderFactoryService} from "./header-factory.service";
import {MySubscriptionsFactory} from "../my-subscriptions/my-subscriptions-factory.service";
import {catchError} from "rxjs/operators";
import {ActivityFactory} from "../activity/activity-factory.service";
import {SharedService} from "../service/shered.service";
import {SharedConstants} from "../utilityClass/sharedConstants";
import {ActivityTabs} from "../enums/activity-tabs";
import {Team} from "../interface/team";
import {TeamService} from "../service/team.service";
import {Language} from "../models/language";
import {LANG} from "../constants/local-storage.contant";
import {CookieUtils} from "../utils/cookie.utils";
import {TranslateService} from "@ngx-translate/core";
import {LanguageService} from "../service/language.service";
import {MockupDataModel} from "../qr-copy-message/mockup-data.model";
import {SnackBarUtil} from "../qr-copy-message/snack-bar-util.service";
import {FeeStateService} from "../service/fee-state.service";
import {FeeService} from "../service/fee.service";
import {UserIndustryResponse} from "../interface/fee.interface";

const FEE_ADD_MENU_OPTION = {
  member: 'member',
  group: 'group',
} as const;

const FEE_ADD_BUTTON_LABEL = {
  addMember: 'fee.actions.add_member',
  addGroup: 'fee.actions.add_group',
} as const;

type FeeAddMenuSelected = typeof FEE_ADD_MENU_OPTION[keyof typeof FEE_ADD_MENU_OPTION] | null;

const MIN_CARD_ID_LENGTH = 0;


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss', './header-media.component.scss', './user-info-menu.scss']
})
export class HeaderComponent implements OnInit, OnDestroy, DoCheck {
  private readonly defaultFeeLogoIcon = 'assets/fee-icons/Placeholder.svg';

  @Input() name!: string;
  @Input() surname!: string;
  @Input() email!: string;
  @Input() phone!: string;
  @Input() id!: bigint;
  @Input() profileImageUrl: string | null | undefined;
  @Input() default: boolean = true;

  @Output() openSidebarEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('feeAddSplitBtn') feeAddSplitBtn?: ElementRef<HTMLElement>;
  @ViewChild('feeAddBtnLeft') feeAddBtnLeft?: ElementRef<HTMLElement>;
  @ViewChild('feeAddSplitBtnMobile') feeAddSplitBtnMobile?: ElementRef<HTMLElement>;
  @ViewChild('feeAddBtnLeftMobile') feeAddBtnLeftMobile?: ElementRef<HTMLElement>;

  isAdmin: boolean = false;
  isListView: boolean = false;
  isHistoryRoute: boolean = false;
  isActivityRoute: boolean = false;
  isInsightsRoute: boolean = false;
  isTeamRoute: boolean = false;
  isSearchMobileActive: boolean = false;
  isViewedCards: boolean = true;
  isFeeDetailRoute: boolean = false;
  isFeeMemberProfileRoute: boolean = false;
  isAddMemberRoute: boolean = false;
  activeUserIndustry: UserIndustryResponse | null = null;
  activeFeeLogoUrl: string | null = null;
  feeHeaderGroupName = '';
  feeHeaderSubgroupName = '';
  feeHeaderGroupId: number | null = null;
  feeHeaderSubgroupId: number | null = null;
  private lastKnownPath = '';
  menuOpen = false
  currentRoute: string | null = null;
  showTextTitleAndLength: string | any;
  dialogRef: MatDialogRef<DeleteProfileCardComponent> | undefined;
  isMenuOpen = false;
  isFeeAddMenuOpen = false;
  isCompactFeeActionViewport = false;
  feeAddMenuSelected: FeeAddMenuSelected = FEE_ADD_MENU_OPTION.member;
  feeAddMenuWidthPx: number | null = null;
  teams: Team[] = []
  currentTeam!: Team
  selectedTeam!: Team | null

  protected isSearchOpened: boolean = false;
  protected cardsCount: number = 0;
  protected isCardsCountVisible: boolean = true;
  protected isOnlySearchVisible: boolean = false;
  protected pageTitle: string = '';
  protected isPlanSubscriptionPage: boolean = false;
  protected isActivityPage = ActivityTabs.ALL_INDIVIDUAL;
  protected isMyPlanActive: boolean = false;
  protected isClearHistoryButtonActive: boolean = false;

  private currentProfileImageUrl: string = '';
  private routerSubscription: Subscription | undefined;
  private languageSubscription: Subscription | undefined;
  private myPlanActiveSubscription?: Subscription;
  private feeStateSubscription?: Subscription;
  private feeHeaderContextSubscription?: Subscription;

  readonly EDIT_CONTAINER_CLASS = 'edit-container';

  lang = '';

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private userService: UserService,
    private userCardService: UserCardService,
    private viewStateService: ViewStateService,
    private headerDataService: HeaderDataService,
    private scannedHistoryService: CardsHistoryService,
    private favoriteCardsService: FavoriteCardsService,
    private snackBar: SnackBarUtil,
    private sharedService: SharedService,
    private route: ActivatedRoute,
    private teamService: TeamService,
    private translateService: TranslateService,
    private languageService : LanguageService,
    private feeStateService: FeeStateService,
    private feeService: FeeService,
    private cdr: ChangeDetectorRef
    ) {
    HeaderFactoryService.cardsCount.subscribe({
      next: (count: number) => {
        this.cardsCount = count;
      }
    });
    HeaderFactoryService.isViewedCards.subscribe({
      next: (isViewedCards: boolean) => {
        this.isViewedCards = isViewedCards;
        this.updateViewedCardsTitle(isViewedCards);
      }
    });
    this.myPlanActiveSubscription = MySubscriptionsFactory.isMyPlanActive.subscribe({
      next: (isMyPlanActive: boolean) => {
        if (this.isMyPlanActive !== isMyPlanActive) {
          this.isMyPlanActive = isMyPlanActive;
        }
      }
    })

    this.isMyPlanActive = MySubscriptionsFactory.isMyPlanActive.value;
    ActivityFactory.isIndividualActive.subscribe({
      next: (isIndividualActive: string) => {
        this.isActivityPage = isIndividualActive as ActivityTabs;
      }
    })
  }

  ngOnInit(): void {
    this.updateFeeActionViewportState();
    this.resetTransientHeaderState();
    this.updateCurrentRoute();
    this.lastKnownPath = this.getCurrentPath();
    this.lang = this.languageService.getLanguageFromStorage();
    this.translateService.use(this.lang);

    this.languageSubscription = this.languageService.currentLanguage$.subscribe({
      next: (lang: string) => {
        if (this.lang !== lang) {
          this.lang = lang;
          this.initPageTitle();
          if (this.router.url.includes('/history')) {
            this.updateViewedCardsTitle(this.isViewedCards);
          }
        }
      }
    });

    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe({
        next: () => {
          const currentUrl = this.router.url;
          if (!currentUrl.includes('/cards') && !currentUrl.includes('/create-card')) {
            HeaderFactoryService.cardsCount.next(0);
          }
          this.resetTransientHeaderState();
          this.updateCurrentRoute();
          this.updateRoutes();
          this.initPageTitle();

          if (currentUrl.includes('/history')) {
            this.updateViewedCardsTitle(this.isViewedCards);
          }

          this.cdr.markForCheck();
        }
      });
    if (this.userService.role === UserRole.ADMIN) {
      this.isAdmin = true;
    } else {
      this.isAdmin = false;
      this.userService.getCurrentProfileImageUrl().subscribe({
        next: (response) => {
          this.profileImageUrl = response
        }
      })
    }
    this.updateRoutes();
    this.initPageTitle();
    this.headerDataService.setId(this.id);
    this.getCurrentUserTeam();
    this.subscribeToViewState();
    this.feeStateSubscription = this.feeStateService.activeUserIndustry$.subscribe(ui => {
      this.activeUserIndustry = ui;
      this.activeFeeLogoUrl = this.feeService.getLogoUrl(ui?.logoPath) ?? this.defaultFeeLogoIcon;
      this.cdr.markForCheck();
    });
    this.feeHeaderContextSubscription = this.feeStateService.feeHeaderContext$.subscribe(context => {
      if (!this.isFeeMemberProfileRoute) {
        this.feeHeaderGroupName = '';
        this.feeHeaderSubgroupName = '';
        this.feeHeaderGroupId = null;
        this.feeHeaderSubgroupId = null;
        this.cdr.markForCheck();
        return;
      }
      this.feeHeaderGroupName = context?.groupName || '';
      this.feeHeaderSubgroupName = context?.subgroupName || '';
      this.feeHeaderGroupId = context?.groupId ?? null;
      this.feeHeaderSubgroupId = context?.subgroupId ?? null;
      this.cdr.markForCheck();
    });
  }

  ngDoCheck(): void {
    const currentPath = this.getCurrentPath();
    if (currentPath === this.lastKnownPath) return;
    this.lastKnownPath = currentPath;
    this.updateCurrentRoute();
    this.updateRoutes();
    this.initPageTitle();
    if (currentPath.includes('/history')) {
      this.updateViewedCardsTitle(this.isViewedCards);
    }
  }

  changeLang(lang: string) {
    this.languageService.setLanguage(lang);
  }

  getTeamsForCurrentUserAsMember() {
    if (!this.currentTeam.requestAllowed){
      this.teamService.getAllTeamsByCurrentMember().subscribe({
        next: (teams) => {
          this.teams = teams;
        }
      })
    }else {
      this.teamService.getTeamsByCurrentMember().subscribe({
        next: (teams) => {
          this.teams = teams;
        }
      })
    }
  }

  private getCurrentUserTeam(trimmedQuery?: string) {
    this.teamService.getCurrentUserTeam().subscribe({
      next: (team) => {
        if (team) {
          this.currentTeam = team
          this.getTeamsForCurrentUserAsMember()
        }
      }
    })
  }

  clearHistory(event: any): void {
    event.stopPropagation()
    const deleteTitle = this.isViewedCards ? DELETE_ALL_VIEWED_CARD_TITLE : DELETE_ALL_FAVORITES_CARD_TITLE;
    this.dialogRef = this.dialog.open(DeleteProfileCardComponent, {
      data: {
        deleteTitle: deleteTitle,
        deleteDescription: DELETE_DESCRIPTION,
      }
    });
    this.dialogRef.afterClosed().subscribe({
      next: (result: MatDialogRef<DeleteProfileCardComponent>) => {
        if (result) {
          if (this.isViewedCards) {
            this.scannedHistoryService.deleteAllByLoggedUser().subscribe({
              next: () => {
                this.viewStateService.setIsClearHistory(true)
              }
            });
          } else {
            this.favoriteCardsService.deleteAllFavoriteCardsByUser().subscribe({
              next: () => {
                this.viewStateService.setIsClearHistory(false)
              }
            });
          }
        }
      }
    });
  }

  toggleViewList(isGrid: boolean): void {
    this.isListView = isGrid;
    this.viewStateService.setListView(isGrid);
  }

  toggleMobileSearch(isSearchMobileActive: boolean): void {
    this.isSearchMobileActive = isSearchMobileActive;
  }

  logout(): void {
    this.userService.logout();
  }

  logoutAdmin(): void {
    this.userService.logoutAdmin();
  }

  showProfileEdit(): void {
    this.userService.currentUser.pipe(take(1)).subscribe({
      next: (user) => {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
          user: user,
          profileImageUrl: this.currentProfileImageUrl
        };

        dialogConfig.panelClass = this.EDIT_CONTAINER_CLASS;

        const dialogRef = this.dialog.open(UserEditProfileComponent, dialogConfig);

        dialogRef.afterClosed().subscribe({
          next: (data: any) => {
            if (data?.isPictureChanged) {
              this.updateUserDetails(data.isPictureChanged);
            }
          }
        });
      }
    });
  }

  returnToPreviousPage() {
    this.router.navigate([this.currentRoute]);
  }

  navigateToIndustryCard(cardId: string): void {
    this.router.navigate(['/', cardId]);
  }

  formatCardUsername(cardId: string): string {
    return '@' + cardId.replace(/^@+/, '');
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
    if (this.myPlanActiveSubscription) {
      this.myPlanActiveSubscription.unsubscribe();
    }
    if (this.feeStateSubscription) {
      this.feeStateSubscription.unsubscribe();
    }
    if (this.feeHeaderContextSubscription) {
      this.feeHeaderContextSubscription.unsubscribe();
    }
  }

  private updateCurrentRoute(): void {
    if (this.router.url === '/create-card') {
      this.currentRoute = '/cards';
    } else {
      this.currentRoute = this.route.snapshot.queryParamMap.get('currentRoute');
    }
  }

  private updateUserDetails(isPictureChanged: boolean): void {
    this.userService.currentUser.subscribe({
      next: (user) => {
        if (isPictureChanged) {
          this.getProfileImage(user.id);
          this.userService.setCurrentProfileImageUrl(user.profileImageUrl);
          this.profileImageUrl = user.profileImageUrl;
        }
        this.name = user.name;
        this.surname = user.surname;
        this.email = user.email;
        this.phone = user.phoneNumber;
      }
    });
  }

  getProfileImageUrl(): string {
    if (this.isAdmin) {
      return SCAN_ME_LOGO;
    } else if (this.profileImageUrl) {
      return this.profileImageUrl;
    } else {
      return DEFAULT_USER_ICON;
    }
  }

  getProfileImage(userId: number): void {
    this.userService.getProfileImage(BigInt(userId)).subscribe({
      next: (imageData) => {
        const fileReader = new FileReader();
        fileReader.onload = (event) => {
          this.currentProfileImageUrl = event.target?.result as string;
          this.userService.setCurrentProfileImageUrl(this.currentProfileImageUrl);
        };
        fileReader.readAsDataURL(imageData);
      },
      error: (err: HttpErrorResponse) => {
        this.getProfileImageUrl();
        this.profileImageUrl = DEFAULT_USER_ICON;
      }
    });
  }

  openSidebar() {
    this.openSidebarEmitter.emit(true);
  }

  togglePlan(isMyPlanActive: boolean) {
    if (this.isMyPlanActive === isMyPlanActive) {
      return;
    }

    MySubscriptionsFactory.isMyPlanActive.next(isMyPlanActive);
    MySubscriptionsFactory.isAllSubscriptionActive.next(!isMyPlanActive);
  }

  private isRequestPaymentEnabled(): boolean {
    return (
      this.isActivityPage === ActivityTabs.ALL_INDIVIDUAL ||
      (this.currentTeam?.requestAllowed ?? false) ||
      (!!this.selectedTeam && !this.selectedTeam.requestAllowed)
    );
  }

  private updateIsHistoryRoute(): void {
    this.isHistoryRoute = this.getCurrentPath().includes('/history');
  }

  private updateIsActivityRoute(): void {
    this.isActivityRoute = this.getCurrentPath().includes('/activity');
  }

  private updateIsInsightsRoute(): void {
    this.isInsightsRoute = this.getCurrentPath().includes('/insights');
  }

  private updateIsTeamRoute(): void {
    this.isTeamRoute = this.getCurrentPath().includes('/teams');
  }

  private subscribeToRouterEvents(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe({
      next: () => {
        this.updateRoutes();
      }
    });
  }

  private updateRoutes() {
    this.updateIsHistoryRoute();
    this.updateIsActivityRoute();
    this.updateIsInsightsRoute();
    this.updateIsTeamRoute();
    this.updateIsFeeDetailRoute();
  }

  private resetTransientHeaderState(): void {
    this.isSearchOpened = false;
    this.isSearchMobileActive = false;
    this.isMenuOpen = false;
    this.menuOpen = false;
  }

  private updateIsFeeDetailRoute(): void {
    const path = this.getCurrentPath();
    const wasFeeRoute = this.isFeeDetailRoute;

    this.isFeeMemberProfileRoute = /\/fees\/user-profile\/\d+/.test(path);
    this.isFeeDetailRoute = /\/fees\/\d+/.test(path) || this.isFeeMemberProfileRoute;
    this.isAddMemberRoute = /\/fees\/\d+\/add-member/.test(path);
    this.syncFeeAddMenuSelection(path);

    if (!this.isFeeDetailRoute && wasFeeRoute) {
      this.activeUserIndustry = null;
      this.activeFeeLogoUrl = null;
      this.feeHeaderGroupName = '';
      this.feeHeaderSubgroupName = '';
      this.feeHeaderGroupId = null;
      this.feeHeaderSubgroupId = null;
      this.feeStateService.setActiveUserIndustry(null);
      this.feeStateService.setFeeHeaderContext(null);
      this.cdr.markForCheck();
    } else if (this.isFeeDetailRoute) {
      this.syncFeeHeaderContext();
    }
  }

  private syncFeeHeaderContext(): void {
    if (!this.isFeeMemberProfileRoute) {
      this.feeHeaderGroupName = '';
      this.feeHeaderSubgroupName = '';
      this.feeHeaderGroupId = null;
      this.feeHeaderSubgroupId = null;
      return;
    }

    const path = this.getCurrentPath();
    const memberMatch = path.match(/\/fees\/user-profile\/(\d+)/);
    if (!memberMatch) {
      this.feeHeaderGroupName = '';
      this.feeHeaderSubgroupName = '';
      this.feeHeaderGroupId = null;
      this.feeHeaderSubgroupId = null;
      return;
    }

    const memberId = Number(memberMatch[1]);
    if (Number.isNaN(memberId)) {
      this.feeHeaderGroupName = '';
      this.feeHeaderSubgroupName = '';
      this.feeHeaderGroupId = null;
      this.feeHeaderSubgroupId = null;
      return;
    }

    const urlTree = this.router.parseUrl(this.router.url);
    const industryId = Number(urlTree.queryParams['industryId']);
    if (!Number.isNaN(industryId)) {
      this.feeService.getUserIndustryById(industryId).pipe(take(1)).subscribe({
        next: ui => {
          if (!ui) return;
          this.activeUserIndustry = ui;
          this.activeFeeLogoUrl = this.feeService.getLogoUrl(ui.logoPath) ?? this.defaultFeeLogoIcon;
        }
      });
    }

    const querySubgroupId = Number(urlTree.queryParams['subgroupId']);
    this.feeService.getMemberProfile(memberId).pipe(take(1)).subscribe({
      next: profile => {
        const subgroup = !Number.isNaN(querySubgroupId)
          ? (profile.subgroups.find(sg => sg.id === querySubgroupId) ?? profile.subgroups[0])
          : profile.subgroups[0];

        this.feeHeaderGroupName = subgroup?.groupName || '';
        this.feeHeaderSubgroupName = subgroup?.name || '';
        this.feeHeaderGroupId = subgroup?.groupId ?? null;
        this.feeHeaderSubgroupId = subgroup?.id ?? null;
        this.feeStateService.setFeeHeaderContext({
          groupName: this.feeHeaderGroupName,
          subgroupName: this.feeHeaderSubgroupName,
          groupId: this.feeHeaderGroupId ?? undefined,
          subgroupId: this.feeHeaderSubgroupId ?? undefined,
        });
      },
      error: () => {
        this.feeHeaderGroupName = '';
        this.feeHeaderSubgroupName = '';
        this.feeHeaderGroupId = null;
        this.feeHeaderSubgroupId = null;
        this.feeStateService.setFeeHeaderContext(null);
      }
    });
  }

  goToFeeHeaderGroup(): void {
    const industryId = this.activeUserIndustry?.id;
    if (!industryId || !this.feeHeaderGroupId) return;
    this.router.navigate(['/fees', industryId, 'groups', this.feeHeaderGroupId]);
  }

  goToFeeHeaderSubgroup(): void {
    const industryId = this.activeUserIndustry?.id;
    if (!industryId || !this.feeHeaderGroupId || !this.feeHeaderSubgroupId) return;
    this.router.navigate(['/fees', industryId, 'groups', this.feeHeaderGroupId], {
      queryParams: { subgroupId: this.feeHeaderSubgroupId }
    });
  }

  onFeeLogoError(): void {
    this.activeFeeLogoUrl = this.defaultFeeLogoIcon;
  }

  openFeeAddMemberPage(): void {
    if (this.isFeeAddActionDisabled) return;
    this.feeAddMenuSelected = FEE_ADD_MENU_OPTION.member;
    const industryId = this.resolveCurrentIndustryId();
    if (industryId === null) return;

    const path = this.getCurrentPath();
    const groupMatch = path.match(/\/fees\/\d+\/groups\/(\d+)/);
    const urlTree = this.router.parseUrl(this.router.url);
    const subgroupId = urlTree.queryParams['subgroupId'];

    const queryParams: { groupId?: number; subgroupId?: number } = {};
    if (groupMatch) {
      const groupId = Number(groupMatch[1]);
      if (!Number.isNaN(groupId)) queryParams.groupId = groupId;
    }
    if (subgroupId) {
      const parsedSubgroupId = Number(subgroupId);
      if (!Number.isNaN(parsedSubgroupId)) queryParams.subgroupId = parsedSubgroupId;
    }

    this.router.navigate(['/fees', industryId, 'add-member'], { queryParams });
  }

  private resolveCurrentIndustryId(): number | null {
    const path = this.getCurrentPath();

    if (!/\/fees\/user-profile\//.test(path)) {
      const feeMatch = path.match(/\/fees\/(\d+)/);
      if (feeMatch) {
        const parsed = Number(feeMatch[1]);
        if (!Number.isNaN(parsed)) return parsed;
      }
    }

    const urlTree = this.router.parseUrl(this.router.url);
    const industryIdParam = urlTree.queryParams['industryId'];
    if (industryIdParam !== undefined && industryIdParam !== null) {
      const parsed = Number(industryIdParam);
      if (!Number.isNaN(parsed)) return parsed;
    }

    return null;
  }

  openSelectedFeeAction(): void {
    if (this.isFeeAddActionDisabled) return;
    if (this.feeAddMenuSelected === FEE_ADD_MENU_OPTION.group) {
      this.openFeeCreateGroupPage();
      return;
    }

    this.openFeeAddMemberPage();
  }

  onFeeAddMenuOpened(triggerButton?: HTMLElement): void {
    this.isFeeAddMenuOpen = true;
    if (this.isCompactFeeActionViewport && typeof window !== 'undefined') {
      this.feeAddMenuWidthPx = Math.max(220, window.innerWidth - 24);
      return;
    }

    this.feeAddMenuWidthPx = this.feeAddSplitBtn?.nativeElement.getBoundingClientRect().width
      ?? this.feeAddSplitBtnMobile?.nativeElement.getBoundingClientRect().width
      ?? triggerButton?.getBoundingClientRect().width
      ?? this.feeAddBtnLeft?.nativeElement.getBoundingClientRect().width
      ?? this.feeAddBtnLeftMobile?.nativeElement.getBoundingClientRect().width
      ?? null;
  }

  openFeeCreateGroupPage(): void {
    if (this.isFeeAddActionDisabled) return;
    this.feeAddMenuSelected = FEE_ADD_MENU_OPTION.group;
    const industryId = this.resolveCurrentIndustryId();
    if (industryId === null) return;

    this.router.navigate(['/fees', industryId, 'groups', 'create'], {
      queryParams: { returnUrl: this.router.url }
    });
  }

  protected isCardsPageRoute(): boolean {
    return this.getCurrentPath() === '/cards';
  }

  protected isTeamsPageRoute(): boolean {
    return this.getCurrentPath().includes('/teams');
  }

  protected isHistoryPageRoute(): boolean {
    return this.getCurrentPath().includes('/history');
  }

  protected isEditCardsPageRoute(): boolean {
    return this.getCurrentPath().includes('/cards/edit');
  }

  protected isActivityPageRoute(): boolean {
    return this.getCurrentPath().includes('/activity');
  }

  protected isMenuPageRoute(): boolean {
    return this.getCurrentPath().includes('/menu');
  }

  protected isCurrentFeeRoute(): boolean {
    return this.isFeeDetailRoute;
  }

  protected get isFeeAddActionDisabled(): boolean {
    if (!this.isCurrentFeeRoute()) return false;
    if (!this.activeUserIndustry) return true;
    return !this.hasLinkedFeeCard(this.activeUserIndustry);
  }

  private hasLinkedFeeCard(industry: UserIndustryResponse | null): boolean {
    return !!industry
      && !!industry.cardId
      && industry.cardId.toString().trim().length > MIN_CARD_ID_LENGTH;
  }

  protected isCurrentFeeAddMemberRoute(): boolean {
    return /\/fees\/\d+\/add-member/.test(this.getCurrentPath());
  }

  protected isFeeGroupsSectionRoute(): boolean {
    return /\/fees\/\d+\/groups(?:\/|$)/.test(this.getCurrentPath());
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.updateFeeActionViewportState();
  }

  private getCurrentPath(): string {
    return this.router.url.split('?')[0];
  }

  private updateFeeActionViewportState(): void {
    this.isCompactFeeActionViewport = typeof window !== 'undefined' && window.innerWidth <= 800;
  }

  private subscribeToViewState(): void {
    this.viewStateService.showTextTitleAndLengthSubject$.subscribe({
      next: (cardsNameAndLength) => {
        this.showTextTitleAndLength = cardsNameAndLength;
      }
    });
    this.viewStateService.isViewedCards$.subscribe({
      next: (isViewedCards) => {
        this.isViewedCards = isViewedCards;
        this.updateViewedCardsTitle(isViewedCards);
      }
    });
    this.viewStateService.isListView$.subscribe({
      next: (isListView) => {
        this.isListView = isListView;
      }
    });
    this.viewStateService.isClearHistoryActiveOnHeader$.subscribe({
      next: (isClearHistory) => {
        this.isClearHistoryButtonActive = isClearHistory;
      }
    })
  }

  openCreateCard(): void {
    this.userCardService.checkIsUserSubscriptionValidForCreatingCard().pipe(
      catchError(error => {
        if (error.status === 409) {
          this.router.navigate(['/subscriptions'], {state: {isShowAllSubscriptions: true}});
          this.showSnackbar(MockupDataModel.error(this.translateService.instant('user_card.create_card_limit_error')), SnackBarUtil.CLASSES.error)
        }
        return of(false);
      })
    ).subscribe({
      next: (response) => {
        if (response) {
          this.router.navigate(['/create-card']);
        }
      }
    })
  }

  toggleIndividual(isIndividualActive: string) {
    this.isActivityPage = isIndividualActive as ActivityTabs
    if (isIndividualActive === ActivityTabs.ALL_TEAMS) {
      this.isMenuOpen = !this.isMenuOpen
    } else {
      ActivityFactory.selectedTeam.next(null)
      this.selectedTeam = null
    }
    ActivityFactory.currentTeam.next(this.currentTeam)
    ActivityFactory.isIndividualActive.next(isIndividualActive)
    ActivityFactory.isIndividualActiveInSight.next(this.isRequestPaymentEnabled())
    this.sharedService.updateActivityList();
  }

  selectTeam(team: Team) {
    this.selectedTeam = team
    this.isMenuOpen = !this.isMenuOpen
    ActivityFactory.selectedTeam.next(team)
    ActivityFactory.isIndividualActiveInSight.next(this.isRequestPaymentEnabled())
    this.sharedService.updateActivityList();
  }

  private initPageTitle() {
    let currentUrl = this.router.url;

    if (currentUrl.includes('cards')) {
      this.setPageTitleConfig(true, false, false, 'sidebar.individual_cards');
    } else if (currentUrl.includes('team')) {
      this.setPageTitleConfig(true, false, false, 'my_team.members');
    } else if (currentUrl.includes('subscriptions')) {
      this.setPageTitleConfig(false, true, true, 'Subscriptions');
    } else if (currentUrl.includes('activity')) {
      this.setPageTitleConfig(false, true, false, 'Activity');
    } else if (currentUrl.includes('insights')) {
      this.setPageTitleConfig(false, true, false, 'insights.sidebar_item');
    } else if (currentUrl.includes('history')) {
      this.setPageTitleConfig(true, false, false, 'cards_library.viewed_cards');
    } else if (currentUrl.includes('menu')) {
      this.setPageTitleConfig(false, false, false, 'menu_management.title');
    } else if (currentUrl.includes('fees')) {
      this.setPageTitleConfig(false, false, false, 'fee.title');
    } else {
      this.setPageTitleConfig(false, false, false, '');
    }
  }

  private setPageTitleConfig(isCardsCountVisible: boolean, isOnlySearchVisible: boolean, isPlanSubscriptionPage: boolean, translationKey: string): void {
    this.isCardsCountVisible = isCardsCountVisible;
    this.isOnlySearchVisible = isOnlySearchVisible;
    this.isPlanSubscriptionPage = isPlanSubscriptionPage;
    if (!translationKey) {
      this.pageTitle = '';
      return;
    }
    this.translateService.get(translationKey).subscribe({
      next: (translation) => {
        this.pageTitle = translation;
      }
    });
  }

  private showSnackbar(data: MockupDataModel, panelClassNames: string[]): void {
    this.snackBar.openSnackBar({
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: panelClassNames,
      data: data
    });
  }

  protected readonly SharedConstants = SharedConstants;
  protected readonly ActivityTabs = ActivityTabs;
  protected readonly Language = Language;

  private syncFeeAddMenuSelection(path: string): void {
    if (/\/fees\/\d+\/add-member/.test(path)) {
      this.feeAddMenuSelected = FEE_ADD_MENU_OPTION.member;
      return;
    }

    if (/\/fees\/\d+\/groups\/create/.test(path)) {
      if (this.feeAddMenuSelected !== FEE_ADD_MENU_OPTION.group) {
        this.feeAddMenuSelected = FEE_ADD_MENU_OPTION.group;
      }
      return;
    }

    this.feeAddMenuSelected = this.isCurrentFeeRoute() ? FEE_ADD_MENU_OPTION.member : null;
  }

  get feeAddButtonLabel(): string {
    return this.feeAddMenuSelected === FEE_ADD_MENU_OPTION.group
      ? FEE_ADD_BUTTON_LABEL.addGroup
      : FEE_ADD_BUTTON_LABEL.addMember;
  }

  private updateViewedCardsTitle(isViewedCards: boolean): void {
    if (this.router.url.includes('/history')) {
      const key = isViewedCards ? 'cards_library.viewed_cards' : 'cards_library.favorites';
      this.translateService.get(key).subscribe({
        next: (translation) => {
          this.pageTitle = translation;
        }
      });
    }
  }
}
